export const TAB_WIDTH = 220;
export const TAB_SPACING = 8;
export const DROPDOWN_BUTTON_WIDTH = 48;
export const RESIZE_DEBOUNCE_MS = 100;
